export default __webpack_public_path__ + "static/media/Itiniraires.17b75e20.svg";